import { AsyncStateNotification } from '@ui/notifications';
import { coreActions } from '@sonar-software/sonar-core';
import { handleEnter } from '@lib/events';
import { Col, Row } from 'antd';
import { COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { Email, FirstName, LastName } from '@ui/form-items';
import { PopoverModal } from '@ui/modals';
import React, { useCallback, useEffect } from 'react';
import { useAction, useAppNotifications, useForm, useInvite } from '@hooks';
export const AddNewUserModal = ({ isOpen, onCancel, popoverPosition, popoverTarget }) => {
    const { errorNotification, successNotification } = useAppNotifications();
    const { finished, idle, invite, loading, reset, result } = useInvite();
    const reloadUsers = useAction(coreActions.repeatGetCoreCustomersByIdUsers);
    const { Form, form } = useForm({
        required: ['firstName', 'lastName', 'email']
    });
    useEffect(() => {
        if (!finished || !result) {
            return;
        }
        if (result === null || result === void 0 ? void 0 : result.invalidUsers.length) {
            errorNotification(NOTIFICATIONS_COPY.FAILED_USER_INVITE);
        }
        else {
            successNotification(NOTIFICATIONS_COPY.SUCCESS_USER_INVITE);
            reloadUsers();
            form.reset();
        }
    }, [errorNotification, finished, form, reloadUsers, result, successNotification]);
    const handleOnFinish = useCallback(() => {
        const { email, firstName, lastName } = form.getFieldsValue();
        invite({
            users: [
                {
                    email: email.trim(),
                    firstName,
                    lastName
                }
            ]
        });
    }, [form, invite]);
    const handleOnValuesChange = useCallback(() => {
        if (!idle && !loading) {
            reset();
        }
        form.validate();
    }, [form, idle, loading, reset]);
    const handleCancel = useCallback(() => {
        if (onCancel) {
            onCancel();
        }
        form.reset();
    }, [form, onCancel]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PopoverModal, { className: 'add-new-user-modal', confirmLoading: loading, destroyOnHidden: true, okButtonProps: {
                disabled: !form.isValid,
                id: 'invite-user-submit-button'
            }, okText: COPY_SPECIFIC.ADD_NEW_USER, onCancel: handleCancel, onOk: handleOnFinish, open: isOpen, popoverPosition: popoverPosition, popoverTarget: popoverTarget, title: COPY_SPECIFIC.ADD_A_NEW_USER },
            React.createElement(Form, { form: form, layout: 'vertical', onFinish: handleOnFinish, onKeyUp: handleEnter(() => form.submit()), onValuesChange: handleOnValuesChange, requiredMark: false },
                React.createElement(Row, { gutter: 16 },
                    React.createElement(Col, null,
                        React.createElement(FirstName, { autoFocus: true, disabled: loading, id: 'invite-user-first-name', label: COPY_SPECIFIC.FIRST_NAME })),
                    React.createElement(Col, null,
                        React.createElement(LastName, { disabled: loading, id: 'invite-user-last-name', label: COPY_SPECIFIC.LAST_NAME }))),
                React.createElement(Email, { disabled: loading, id: 'invite-user-email', label: COPY_SPECIFIC.EMAIL }))),
        React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_USER_INVITE, failed: NOTIFICATIONS_COPY.ERROR_USER_INVITE, resetAction: reset, stateSelector: useInvite.selectors.state })));
};
